<table
  data-test="DtXI4mYk"
  class="items-table items-table_light items-table_transparent items-table_md m-0"
>
  <thead data-test="AmiTXJ9E">
    <tr data-test="JusSILig" class="items-table__header">
      <th data-test="mKXwN7Uj">
        <span data-test="Z9ZDHyGO">Permission area</span>
      </th>
      <th data-test="2gjmtSzd" class="text-right">
        <span data-test="urArHwh-">Acces level</span>
      </th>
    </tr>
  </thead>
  <tbody data-test="yazVUYG5">
    <ng-container *ngFor="let permission of allPermissions">
      <tr
        data-test="Cvjp37dB"
        *ngIf="permission.type === 'module'"
        class="parent"
        [ngStyle]="{ display: !!permission.parent ? 'none' : 'table-row' }"
        [ngClass]="
          'sublevel-' +
          permission.sublevel +
          ' ' +
          (permission.parent ? permission.parent + '_child' : '')
        "
        [attr.tab]="tab"
        [attr.module-name]="permission.type === 'module' ? permission.path : null"
        (click)="toggleClass($event, 'active')"
      >
        <td data-test="3m5zpSP-">
          <button data-test="dAcXb7BM" class="items-table__toggle items-table__icon">
            <span data-test="RdwbaKKV" class="badge badge_gray">
              <i data-test="kReiQEHo" class="material-icons md-16">
                keyboard_arrow_right
              </i>
            </span>
          </button>
          <b data-test="vDnjqo-w">{{ permission.name }}</b>
        </td>
        <td data-test="4ku0uoIN" class="text-right">
          <span
            data-test="mW4RQg7r"
            *ngIf="getModuleAccessLevel(permission) === 'custom'"
            class="label label_bordered label_bordered-gray"
          >
            CUSTOM
          </span>
          <span
            data-test="-ngLnCXG"
            *ngIf="getModuleAccessLevel(permission) === 'all'"
            class="text-green"
          >
            <i data-test="SfDtgkcX" class="material-icons md-24">{{ 'check_circle' }}</i>
          </span>
          <span
            data-test="1VUajN6r"
            *ngIf="getModuleAccessLevel(permission) === 'none'"
            class="text-red"
          >
            <i data-test="OSQezED3" class="material-icons md-24">{{ 'remove_circle' }}</i>
          </span>
        </td>
      </tr>
      <tr
        data-test="-fNqusBV"
        class="row-bg"
        [ngClass]="
          'sublevel-' +
          permission.sublevel +
          ' ' +
          (permission.parent ? permission.parent + '_child' : '')
        "
        *ngIf="permission.type === 'permission'"
        [attr.module-name]="permission.parent"
        [attr.tab]="tab"
        [ngStyle]="{ display: !!permission.parent ? 'none' : 'table-row' }"
      >
        <td data-test="ZPeNkxMn">
          <a data-test="RtZjH9Ab" class="link-light d-flex align-items-center" href="#">
            <span data-test="5i0CmEnG" class="mr-2">
              <svg
                data-test="oLgjkE5b"
                class="icon__icon-additional"
                width="18px"
                height="21px"
              >
                <use xlink:href="#icon-additional"></use>
              </svg>
            </span>
            <span data-test="PZR9mWGg">{{ permission.name }}</span>
          </a>
        </td>
        <td data-test="hLKczvNC" class="text-right">
          <span
            data-test="GZeekUCl"
            [ngClass]="{
              'text-red': !checkPermission(permission),
              'text-green': checkPermission(permission)
            }"
          >
            <i data-test="ic51lYXQ" class="material-icons md-24">
              {{ checkPermission(permission) ? 'check_circle' : 'remove_circle' }}
            </i>
          </span>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
